import Vue from 'vue';
import Router from 'vue-router';
import config from '@/config';
import {
  refreshToken,
  getDistributorErpConfig,
  getAccessToken, getQueryMenu, getSinglePageRoleCommon, getStoreDomainName
} from '@/utils/user';
import {getToken} from "@/utils/cookie";
import {
  getCurrencyData, getDistributorId,
  getShopDomain, deleteTicket, getConfigurationItemData, showPageInitFailureModal,
  isInterceptorHandled, resetInterceptorHandled, isChunkLoadError,
} from "@/utils/common";
import {clearAllLoading} from '@/utils/loading';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
let countTime = config.curTime;
const routes = [
  {
    path: '/', // 商城--店铺列表页
    component: () => import('@/views/shopping/storeList/components/shopList')
  }
];
const router = new Router({
  // mode: 'hash',
  mode: 'history',
  routes
});

/**
 * 初始化店铺列表页语种和配置项缓存。
 * @returns {Promise<void>}
 */
const initLangAndConfig = async () => {
  const lang = getStoreDomainName();
  if (lang) {
    localStorage.setItem('lang', lang);
    Vue.config.lang = lang;
  }
  await getConfigurationItemData();
};

/**
 * 统一处理店铺列表页初始化失败场景。
 * @param {Function} next vue-router 导航回调。
 * @param {Error} error 当前初始化异常。
 */
const handlePageInitFailure = (next, error) => {
  console.error('router beforeEach error:', error);
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  next(false);
  if (isInterceptorHandled) {
    resetInterceptorHandled();
    return;
  }
  showPageInitFailureModal();
}

router.beforeEach(async (to, from, next) => {
  localStorage.setItem('system', 'shopping');
  const localUrl = window.location.href;
  const origin = window.location.origin;
  try {
    /* ========== 1. ticket 登录回调 ========= */
    if (localUrl.includes('ticket')) {
      try {
        await getAccessToken(localUrl, true);
      } finally {
        clearAllLoading();
        window.location.href = deleteTicket(localUrl);
        setTimeout(() => window.location.reload(), 800);
      }
      return;
    }
    /* ========== 2. 正常进入 ========= */
    refreshToken(countTime, true);
    const token = getToken();
    if (token) {
      const menu = await getQueryMenu('yms-distributor-service');
      if (menu === null) {
        clearAllLoading();
        resetInterceptorHandled();
        return next(false);
      }
      if (menu === false) {
        throw new Error('getQueryMenu failed');
      }
      const [erpConfig, shopDomain, distributorId, role] = await Promise.all([
        getDistributorErpConfig(),
        getShopDomain(),
        getDistributorId(origin),
        getSinglePageRoleCommon('shop_shopList', 'yms-distributor-service'),
        getCurrencyData()
      ]);
      if (erpConfig === false) {
        throw new Error('getDistributorErpConfig failed');
      }
      if (shopDomain === false) {
        throw new Error('getShopDomain failed');
      }
      if (distributorId === false) {
        throw new Error('getDistributorId failed');
      }
      if (role === false) {
        throw new Error('getSinglePageRoleCommon failed');
      }
      if (erpConfig && shopDomain && distributorId && role) {
        await initLangAndConfig();
        clearAllLoading();
        return next();
      }
    } else {
      const [erpConfig, shopDomain, distributorId] = await Promise.all([
        getDistributorErpConfig(),
        getShopDomain(),
        getDistributorId(origin)
      ]);
      if (erpConfig === false) {
        throw new Error('getDistributorErpConfig failed');
      }
      if (shopDomain === false) {
        throw new Error('getShopDomain failed');
      }
      if (distributorId === false) {
        throw new Error('getDistributorId failed');
      }
      if (erpConfig && shopDomain && distributorId) {
        await initLangAndConfig();
        clearAllLoading();
        return next();
      }
    }
  } catch (err) {
    handlePageInitFailure(next, err);
  }
});
// 路由错误处理
router.onError((error) => {
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  console.error('router error:', error);
});

export default router;
